export default "__VITE_ASSET__COUo_qky__"